import { handleSendFunctionResponseToRFPAgent } from "../services/handleSendFunctionResponseToRFPAgent";

export const getSingleValue = async (section, updatedChatSession, documentData, chatSessionRef, setChatSession, userInfo) => {
    const responseMessage = `FunctionResponse: The value of ${section} is ${documentData[section]}.`
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    };
    await handleSendFunctionResponseToRFPAgent(response, updatedChatSession, setChatSession, chatSessionRef, userInfo);
}